// extracted by mini-css-extract-plugin
export var btnWrap = "product-showcase-module--btnWrap--0a674";
export var grid = "product-showcase-module--grid--a829f";
export var item = "product-showcase-module--item--4bfb9";
export var root = "product-showcase-module--root--64a41";
export var slider = "product-showcase-module--slider--d3ac4";